import { ReadFile } from '@paragon/client-tools';
import { PlatePrice, PlateType } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAllPlatePrices() {
  return DesignService.get<readonly PlatePrice[]>('public/platePrices');
}

export function getMostRecentPlatePrice(plateType: PlateType) {
  return DesignService.get<PlatePrice | null>(`public/platePrices/${plateType}/mostRecent`);
}

export function importPlatePrices(file: ReadFile) {
  return DesignService.post<readonly PlatePrice[]>('platePrices/importPlatePrices', { data: file });
}

export function exportPlatePrices() {
  return DesignService.fetchFile('platePrices/exportPlatePrices');
}

export interface NewPlatePrice {
  readonly plateType: PlateType;
  readonly pricePerPound: number;
  readonly notes: string | null;
}

export function postPlatePrice(newPlatePrice: NewPlatePrice) {
  return DesignService.post<PlatePrice>('public/platePrices', { data: newPlatePrice });
}

export interface PlatePriceEdit {
  readonly guid: string;
  readonly pricePerPound: number;
  readonly notes: string | null;
}

export function putPlatePrices(edits: readonly PlatePriceEdit[]) {
  return DesignService.put<readonly PlatePrice[]>('public/platePrices/bulk', { data: edits });
}
